import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { A11y, Navigation, Pagination } from "swiper/core";
import { array, number } from "prop-types";
import { useEffect, useState } from "react";

import ContentListingItem from "./ContentListingItem.jsx";
import useMatchMedia from "../../common/useMatchMedia.js";
import { nextIcon, prevIcon } from "../../common/icons.jsx";

const propTypes = { results: array, index: number };

const VariantFive = (props) => {
  const { results, index } = props;

  const matchesMobile = useMatchMedia("(max-width: 679px)");

  const [renderSwipers, setRenderSwipers] = useState(false);

  useEffect(() => {
    //required to let text load and prevent swiper init errors
    setRenderSwipers(true);
  }, []);

  SwiperCore.use([A11y, Pagination, Navigation]);

  return (
    <div className="dynamic-content-listing__variant-five">
      <div className="dynamic-content-listing__swiper">
        {renderSwipers && (
          <Swiper
            a11y
            navigation={
              results && results.length > 3
                ? {
                    prevEl: `.dynamic-content-listing__prev-${index}`,
                    nextEl: `.dynamic-content-listing__next-${index}`,
                  }
                : false
            }
            pagination={{ clickable: true }}
            slidesPerView={matchesMobile ? 1 : 3}
            spaceBetween={30}
          >
            {results &&
              results.map((item, i) => (
                <SwiperSlide key={i}>
                  <ContentListingItem
                    key={item.title}
                    displayImage={true}
                    variantType={5}
                    {...item}
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        )}
        {results && results.length > 3 && (
          <>
            <button
              className={`dynamic-content-listing__prev dynamic-content-listing__prev-${index}`}
            >
              {prevIcon}
            </button>
            <button
              className={`dynamic-content-listing__next dynamic-content-listing__next-${index}`}
            >
              {nextIcon}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

VariantFive.propTypes = propTypes;
export default VariantFive;
